import { Loader2 } from "lucide-react";

export default function QuoteSendConfirmModal({ open, quote, saving, onConfirm, onCancel }) {
  if (!open || !quote) return null;
  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-slate-950/40 p-4" data-testid="quote-send-confirm-modal">
      <div className="w-full max-w-sm rounded-2xl bg-white p-6 shadow-2xl dark:bg-[#111C33]">
        <h3 className="text-base font-bold text-slate-950 dark:text-white">Send this quote?</h3>
        <p className="mt-2 text-sm text-slate-600 dark:text-slate-400">
          An email with a secure link will be sent to {quote.contact_email}. The quote will move from Draft to Sent.
        </p>
        <div className="mt-5 flex items-center gap-3">
          <button
            type="button"
            onClick={onConfirm}
            disabled={saving}
            data-testid="quote-send-confirm-btn"
            className="inline-flex items-center gap-2 rounded-xl bg-[#0052FF] px-4 py-2.5 text-sm font-bold text-white hover:bg-blue-700 disabled:opacity-50"
          >
            {saving && <Loader2 size={14} className="animate-spin" />}
            Yes, send quote
          </button>
          <button
            type="button"
            onClick={onCancel}
            disabled={saving}
            data-testid="quote-send-cancel-btn"
            className="rounded-xl border border-slate-300 px-4 py-2.5 text-sm font-bold text-slate-700 hover:bg-slate-50 disabled:opacity-50 dark:border-white/15 dark:text-slate-200 dark:hover:bg-white/10"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
